<template>
  <div
    class="total-card rb shadow"
    :class="activeBtn === cardIndex ? 'active-border' : ''"
  >
    <div class="circle" :class="color">
      <div class="circle-inner"></div>
    </div>
    <div>
      <div class="bold">{{ heading }}</div>
      <div class="light">{{ `${total} students` }}</div>
    </div>
    <div class="click pointer green-alt-txt" @click="handleClick">
      click to view<b-icon icon="arrow-top-right" custom-size="default" />
    </div>
  </div>
</template>

<script>
export default {
  name: "smallStat",
  props: {
    heading: {
      type: String
    },
    total: {
      type: Number,
      default: 0
    },
    color: {
      type: String
    },
    cardIndex: {
      type: Number
    },
    activeBtn: {
      type: Number
    }
  },
  methods: {
    handleClick() {
      this.$emit("cardClicked", this.cardIndex);
    }
  }
};
</script>
